import './analyticsChart.scss';
import AnalyticsChartController from './AnalyticsChartController';
import AnalyticsChartView from './AnalyticsChartView.html';
export class ChartAction {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
ChartAction.$inject = ['init'];
/**
 * These classes are used to dispatch a typed action to parent controller that's using this component
 */
export class Change extends ChartAction {
    static $inject = ['props'];
    constructor(props) {
        super(props);
    }
}
export class Delete extends ChartAction {
    static $inject = ['props'];
    constructor(props) {
        super(props);
    }
}
export class Edit extends ChartAction {
    static $inject = ['props'];
    constructor(props) {
        super(props);
    }
}
/**
 * Component configurations
 */
export const AnalyticsChartComponent = {
    template: AnalyticsChartView,
    controller: AnalyticsChartController,
    controllerAs: '$ctrl',
    bindings: {
        chart: '<',
        categories: '<',
        reportOwner: '<',
        onAction: '&?',
        editMode: '@?',
        isLoading: '<?',
        info: '@?',
    },
};
